if (!window.geoip2) {
  (function () {
    async function getCountry(cb, errorCb) {
      const geoipEndpoint = "/browsing_context_suggestions.json";
      try {
        const dataJson = await fetch(geoipEndpoint);
        const data = await dataJson.json();
        const countryName = data.detected_values.country_name;
        const countryIsoCode = data.detected_values.country.handle;

        window.geoip2_country_code = countryIsoCode;

        const countryInfo = {
          country_name: countryName,
          country: {
            iso_code: countryIsoCode,
            names: {
              en: countryName,
            },
          },
          registered_country: {
            iso_code: countryIsoCode,
            names: {
              en: countryName,
            },
          },
        };
        cb(countryInfo);
      } catch (error) {
        console.error(error);
        errorCb && errorCb(error);
      }
    }

    window.geoip2 = {
      country: getCountry,
    };
  })();
}
